import React, { Component } from "react";

import { Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import contentData from "../utils/contentData";
import { returnTextByOrg } from "../utils/textHelpers";

class Content extends Component {
  render() {
    const hostname = window.location.hostname;
    const splithostname = hostname.split(".");
    let subdomain = splithostname[0];
    let organization,
      connection = "";
    if (
      splithostname.length > 3 ||
      (splithostname.length > 1 && splithostname[1].includes("localhost"))
    ) {
      organization = connection = subdomain;
    }

    return (
      <>
        <style>
          {`
          .content {
            text-align: center;
            // color: white;
            
            ${returnTextByOrg(organization, {
                southcentralpower: "color:white;",
                austinutilities: "color:white;",
                oec: "color:white;",
                nisc: "color:white;",
              })}
            // background: #000;
            // background-color: #fff;
            width: 100%;
            // height: 100%;
            // padding: 30px;
          }
          ul {
            list-style-type: none;
            margin-bottom: 50px;
          }
            .content-title {
              ${returnTextByOrg(organization, {
                southcentralpower: "color:#d87e3f;",
                austinutilities: "color:#84963e;",
                oec: "color:#3a9776;",
                nisc: "color:#89343c;",
              })}
            }
        `}
        </style>

        <div className="next-steps my-5 content">
          {/* <img src="./visionofvalue.jpg" style={{ width: "500px" }} /> */}
          {/* <h2 className="my-5 text-center">Welcome</h2> */}
          <h2 className="mt-3 content-title" style={{ fontSize: "35px" }}>
            {returnTextByOrg(organization, {
              southcentralpower: "South Central Power",
              austinutilities: "Austin Utilities",
              oec: "Oklahoma Electric Cooperative",
              nisc: "At NISC, we have a Vision of Value",
            })}
          </h2>
          {returnTextByOrg(organization, {
            southcentralpower: (
              <div
                style={{
                  height: "4px",
                  backgroundColor: "#fcc424",
                  margin: "15px",
                }}
              />
            ),
            austinutilities: (
              <div
                style={{
                  height: "4px",
                  backgroundColor: "#2e6598",
                  margin: "15px",
                }}
              />
            ),
            oec: (
              <div
                style={{
                  height: "4px",
                  backgroundColor: "#0f4a38",
                  margin: "15px",
                }}
              />
            ),
            nisc: (
              <div
                style={{
                  height: "4px",
                  backgroundColor: "#ac3242",
                  margin: "15px",
                }}
              />
            ),
          })}

          <ul>
            <li style={{ fontSize: "25px" }}>
              {returnTextByOrg(organization, {
                southcentralpower:
                  "Our cooperative exists to add value to the lives of our members by delivering safe and dependable service.",
                austinutilities: "A part of the Austin community.",
                oec: "At OEC, our purpose is to improve our members’ quality of life through the safe delivery of highly reliable, reasonably priced electric service, innovative energy programs and exceptional member service.",
                nisc: `Every day, we strive to provide value in all that we do because we
              understand how important value is to you. Our focus is to solve,
              support and serve with and for our Members and our employees.
              Together, we develop solutions for tomorrow's challenges --today.`,
              })}
            </li>
          </ul>
          {/* <Row className="d-flex justify-content-between">
            {contentData.map((col, i) => (
              <Col key={i} md={5} className="mb-4">
                <h6 className="mb-3">
                  <a href={col.link} target="_blank">
                    <FontAwesomeIcon icon="link" className="mr-2" />
                    {col.title}
                  </a>
                </h6>
                <p>{col.description}</p>
              </Col>
            ))}
          </Row> */}
        </div>
      </>
    );
  }
}

export default Content;
